<template>
  <OurCard class="dealership-application-comment-card mb-4" border-radius="sm">
    <div class="comment-card-wrapper">
      <OurTextField :label="$t('dealershipApplications.commentCreatedAt')" :value="createdAt" />
      <OurTextField :label="$t('label.comment')">
        <span class="comment-body">{{ body }}</span>
      </OurTextField>
      <OurTextField :label="$t('label.userData')">
        <div class="user-data">
          <span>{{ userData.fullName }}</span>
          <span>{{ userData.email }}</span>
        </div>
      </OurTextField>
      <OurTextField
        :label="$t('dealershipApplications.statusWhenCommentAdded')"
        :value="statusAtEventLabel"
      />
    </div>
  </OurCard>
</template>

<script>
export default {
  name: "DealershipApplicationCommentCard",

  props: {
    createdAt: {
      type: String,
      default: "",
    },
    body: {
      type: String,
      default: "",
    },
    userData: {
      type: Object,
      default: () => ({
        fullName: "",
        email: "",
      }),
    },
    statusAtEventLabel: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped lang="postcss">
.dealership-application-comment-card {
  @apply w-full min-w-0 max-w-full;

  .comment-card-wrapper:deep {
    @apply flex w-full min-w-0 flex-col space-y-4;

    .our-text-field {
      @apply w-full min-w-0 max-w-full;
    }

    .user-data {
      @apply flex w-full min-w-0 flex-col gap-1;

      span {
        @apply min-w-0;
        overflow-wrap: anywhere;
        word-break: break-word;
      }
    }

    .comment-body {
      @apply block w-full min-w-0 max-w-full whitespace-pre-wrap text-gray-800;
      overflow-wrap: anywhere;
      word-break: break-word;
    }
  }
}
</style>
